export const rad = (x) => x * Math.PI / 180;

export const findClosestMarker = (data) => {
  const { position, markers } = data;
  const lat = position.lat();
  const lng = position.lng();
  const R = 6371;
  const distances = [];
  let closest = -1;

  for (let i = 0; i < markers.length; i++) {
    const mlat = markers[i].position.lat();
    const mlng = markers[i].position.lng();
    const dLat = rad(mlat - lat);
    const dLong = rad(mlng - lng);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(rad(lat)) * Math.cos(rad(lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c;

    distances[i] = d;

    if (closest === -1 || d < distances[closest]) {
      closest = i;
    }
  }

  return markers[closest];
}

export const calculateBounds = (currentLocation, closestMarker) => {
  const currLat = currentLocation.lat();
  const closestLat = closestMarker.lat();
  const currLng = currentLocation.lng();
  const closestLng = closestMarker.lng();
  let x0;
  let x1;
  let y0;
  let y1;

  if (!closestMarker) {
    x1 = currentLocation.lat();
    y1 = currentLocation.lng();
    x0 = x1;
    y0 = y1;
  }

  if (closestMarker) {
    x0 = currLat < closestLat ? closestLat : currLat;
    x1 = currLat < closestLat ? currLat : closestLat;

    y0 = currLng < closestLng ? closestLng : currLng;
    y1 = currLng < closestLng ? currLng : closestLng;
  }

  const ltnLng1 = new google.maps.LatLng(x1, y1);
  const ltnLng0 = new google.maps.LatLng(x0, y0);

  return new google.maps.LatLngBounds(ltnLng1, ltnLng0);
}

export const latRad = (lat) => {
  const sin = Math.sin(lat * Math.PI / 180);
  const radX2 = Math.log((1 + sin) / (1 - sin)) / 2;

  return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
}

export const latLngZoom = (mapPx, worldPx, fraction) =>
    Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);

export const getBoundsZoomLevel = (bounds, mapDim) => {
  const WORLD_DIM = {
    height: 256,
    width: 256
  };
  const ZOOM_MAX = 18;
  const ZOOM_MIN = 5;

  const ne = bounds.getNorthEast();
  const sw = bounds.getSouthWest();

  const latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

  const lngDiff = ne.lng() - sw.lng();
  const lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;

  const latZoom = latLngZoom(mapDim.height, WORLD_DIM.height, latFraction);
  const lngZoom = latLngZoom(mapDim.width, WORLD_DIM.width, lngFraction);

  return Math.max(Math.min(latZoom, lngZoom, ZOOM_MAX), ZOOM_MIN);
}

export const calculateZoomWithClosestMarker = (data) => {
  const { position, maxZoom, mapContainer } = data;

  if (!(position?.lat && position?.lng)) {
    return maxZoom;
  }

  const closestMarker = findClosestMarker(data);

  if (!closestMarker) {
    return maxZoom;
  }

  const bounds = calculateBounds(position, closestMarker.position);
  const { height, width } = mapContainer.getBoundingClientRect();
  const mapDim = { height: height / 2.2, width: width / 2.2 };

  return getBoundsZoomLevel(bounds, mapDim);
}
